/**
 * Query keys for configuration endpoints.
 *
 * These keys are used with React Query to cache and manage
 * application configuration data like UI metadata.
 */
export const configKeys = {
  all: ['config'] as const,
  uiMetadata: () => [...configKeys.all, 'ui-metadata'] as const,
} as const;
